import { Divider, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { BackNavIcon } from "../../../../assets/common-svg/CommonSvg";
import { useSelector } from "react-redux";
import { selectMessegeUnreadCount } from "../../../slices/chat";

const HeaderChat = ({ handleClose, chatView, setChatView, selectedRoom }) => {
   // const unreadyMessage = useSelector(selectUnreadyMessage)
    const { loginId } = useSelector(
        (state) => state.loginData
    );
    const messegeUnreadCount = useSelector(selectMessegeUnreadCount)
    const [viewMember, setViewMembers] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    // Initialize unread message count from API response
 useEffect(() => {
    if (messegeUnreadCount != null && messegeUnreadCount !== undefined) {
        setUnreadCount(messegeUnreadCount);
    }
}, [ messegeUnreadCount]);

    return (
        <>
            {chatView === "inbox" ? (
                <div className="text-white flex justify-between items-center rounded-t-2xl">
                    <div>
                        <Typography variant="h6" className="text-black">
                            Inbox...
                        </Typography>
                        {unreadCount > 0 && (
                            <span className="text-[#828282] text-[0.8rem]">
                                You have  {unreadCount > 99 ? "99+" : unreadCount} unread notifications
                            </span>
                        )}
                    </div>
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        className="text-black"
                    >
                        ✕
                    </IconButton>
                </div>
            ) : chatView === "chat" ? (
                <>
                    <div className="text-white flex justify-between items-center rounded-t-2xl">
                        <div className="flex gap-2">
                            <div className="mt-[0.4rem] cursor-pointer" onClick={() => setChatView("inbox")}>
                                <BackNavIcon width={15} height={15} />
                            </div>
                            <div className="min-w-0">
                                <div className="flex items-center gap-2 min-w-0">
                                    <Typography
                                        variant="h6"
                                        className="text-black text-sm capitalize whitespace-normal break-words"
                                    >
                                        {selectedRoom?.name}
                                    </Typography>
                                </div>
                                {!viewMember ? (
                                    <span
                                        className="text-[#3571FF] text-[0.7rem] cursor-pointer"
                                        onClick={() => setViewMembers(true)}
                                    >
                                        View Members
                                    </span>
                                ) : (
                                    <span
                                        className="text-[#3571FF] text-[0.7rem] cursor-pointer"
                                        onClick={() => setViewMembers(false)}
                                    >
                                        Hide Members
                                    </span>
                                )}
                            </div>
                        </div>
                        <IconButton
                            size="small"
                            onClick={handleClose}
                            className="text-black"
                        >
                            ✕
                        </IconButton>
                    </div>
                    {viewMember && (
                        <div>
                            <div className="bg-[#F4F6FF] p-3 mt-2 rounded-xl">
                                <div className="grid grid-cols-3 gap-3">
                                    {selectedRoom?.members?.map((user, idx) => (
                                        <div className="flex flex-col" key={idx}>
                                            <span className="text-black text-[0.7rem] capitalize">{user.id == loginId ? "You" : user?.name}</span>
                                            <span className="text-[#828282] text-[0.6rem] capitalize">{user?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}
                    <Divider className="mt-2 w-100" />
                </>
            ) : chatView === "group" ? (
                <div className="text-white flex justify-between items-center rounded-t-2xl">
                    <div className="flex gap-2">
                        <div className="mt-[0.4rem] cursor-pointer" onClick={() => setChatView("inbox")}>
                            <BackNavIcon width={15} height={15} />
                        </div>
                        <div>
                            <div className="flex items-center gap-2">
                                <Typography variant="h6" className="text-black">
                                    New Group
                                </Typography>
                            </div>
                        </div>
                    </div>
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        className="text-black"
                    >
                        ✕
                    </IconButton>
                </div>
            ) : null}
        </>
    );
};

export default HeaderChat;
